import React from 'react';
import { Field, useField } from 'react-final-form';

import { intlShape } from '../../util/reactIntl';
import { propTypes } from '../../util/types';

import { FieldCheckbox, FieldRadioButton } from '../../components';

import css from './AuthenticationPage.module.css';

// Hidden input field
const FieldHidden = props => {
  const { name } = props;
  return (
    <Field id={name} name={name} type="hidden" className={css.unitTypeHidden}>
      {fieldRenderProps => <input {...fieldRenderProps?.input} />}
    </Field>
  );
};

/**
 * Return React Final Form Field that allows selecting user type.
 *
 * @component
 * @param {Object} props
 * @param {string} props.rootClassName - The root class that overrides the default class css.userTypeSelect
 * @param {string} props.className - The class that extends the root class
 * @param {string} props.name - The name of the field / input
 * @param {Array<propTypes.userType>} props.userTypes - The user types
 * @param {boolean} props.hasExistingUserType - Whether the user type already exists
 * @param {intlShape} props.intl - The intl object
 * @returns {JSX.Element}
 */
const FieldSelectUserType = props => {
  const { name, userTypes, hasExistingUserType } = props;
  const hasMultipleUserTypes = userTypes?.length > 1;

  return hasMultipleUserTypes && !hasExistingUserType ? (
    <div>
      <label>{'User type'}</label>
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          marginBottom: '1rem',
          gap: '40%',
        }}
      >
        {userTypes.map((userType, index) => (
          <FieldRadioButton
            key={userType.userType + '-radio'}
            id={name + index}
            name={name}
            value={userTypes[index].userType}
            label={userType.label}
          />
        ))}
      </div>
    </div>
  ) : (
    <>
      <FieldHidden name={name} />
    </>
  );
};

export default FieldSelectUserType;
